"use client";

import { STATS } from "@/lib/site-data";
import { SOCIAL_ICONS } from "@/components/ui/SocialIcons";
import { usePublicSettings } from "@/lib/use-public-settings";

const rating = STATS.find((s) => s.label === "Google Rating")?.value ?? 4.8;
const countries = STATS.find((s) => s.label === "Countries Served")?.value ?? 20;

export function TopBar() {
  const { contact, social } = usePublicSettings();
  return (
    <div className="hidden lg:flex items-center justify-between bg-brand-orange px-6 sm:px-10 py-1.5 text-white">
      <div className="flex items-center gap-5">
        <span className="flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 font-accent text-[11px] uppercase font-semibold">
          <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4 shrink-0">
            <path
              d="M4 12.5 9 17l11-11"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {rating}★ Google Rated · {countries}+ Countries Served
        </span>
        <div className="flex items-center gap-3 border-l border-white/30 pl-5">
          {social.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="text-white/85 hover:text-white hover:scale-110 transition-all"
            >
              {SOCIAL_ICONS[s.label]}
            </a>
          ))}
        </div>
      </div>

      <div className="flex items-center gap-6 font-accent text-[11px] uppercase font-semibold">
        <a
          href={`mailto:${contact.email}`}
          className="flex items-center gap-2 text-white/90 hover:text-white transition-colors"
        >
          <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4 shrink-0">
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
            <path d="m4 6.5 8 6 8-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {contact.email}
        </a>
        <a
          href={contact.phoneHref}
          className="flex items-center gap-2 text-white/90 hover:text-white transition-colors"
        >
          <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4 shrink-0">
            <path
              d="M5 4h3l1.5 4-2 1.5a12 12 0 0 0 6 6l1.5-2 4 1.5v3a1 1 0 0 1-1 1c-8 0-14-6-14-14a1 1 0 0 1 1-1Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
          {contact.phone}
        </a>
      </div>
    </div>
  );
}
